import axios from 'axios'
import moment from 'moment'
// import store from '../../../store'

const setListRecord = ({ commit }, payload) => {
  console.log('setListRecord payload', payload)
  if (!payload.patient) return false
  const { patient, customer } = payload
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/patient/medical-record`, {
      params: {
        customer: customer, // store.state.customer,
        patient: patient
      }
    })
      .then(function (response) {
        // handle success
        const items = response.data.results.results.map((item) => {
          return {
            date: moment(item.tbData, 'DD/MM/YYYY').format('DD/MM/YY'),
            hour: moment(item.tbHora, 'LTS').format('HH'),
            doctor: item.tbNomeMedico === null ? '' : item.tbNomeMedico.substring(0, 10),
            history: item.tbDescricao,
            color: 'purple darken-1',
            icon: 'mdi-book-variant'
          }
        })
        resolve(commit('SET_LISTRECORD', items))
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setCreateRecord = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const { doctor, patient, customer, date, record, description } = payload
    axios.post(`${process.env.URL}/my-clinic-new/patient-record/create`, {
      doctor: doctor,
      patient: patient,
      date: date,
      record: record,
      description: description
    }, {
      params: {
        customer: customer
      }
    }).then((response) => {
      resolve(commit('SET_LISTRECORD', response))
    }).catch((err) => {
      window.console.error('errologin', err)
      reject(err)
    })
  })
}

export default {
  setListRecord,
  setCreateRecord
}



// WEBPACK FOOTER //
// ./src/store/modules/medical-record/actions.js